import Swal from "sweetalert2";
import { get, postAPI } from "../ApiService";

export const userList = async(param) => {
    let res = await get('/urm/user/list/',param);
    return res;
}

